import React from "react";
import { Routes, Route } from "react-router-dom";
import UserManagePage from "./UserManagePage";
import LecturePage from "./lecture/LecturePage";
import AttendancePage from "./AttendancePage";
import QuizPage from "./quiz/QuizPage";
import SurveyPage from "./survey/SurveyPage";
import withNavigation from "../hoc/withNavigation";
import LoginPage from "./user/LoginPage";
import CertificateAddPage from "./certificate/CertificateAddPage";

const Main = () => {
  return (
    <>
      <Routes>
        <Route index element={<LoginPage />} />
        <Route path="attendance/:id" element={<AttendancePage />} />
        <Route path="users" element={<UserManagePage />} />
        <Route path="lecture/*" element={<LecturePage />} />
        <Route path="quiz/*" element={<QuizPage />} />
        <Route path="survey/*" element={<SurveyPage />} />
        <Route path="certificate/upsert" element={<CertificateAddPage />} />
      </Routes>
    </>
  );
};

export default withNavigation(Main);
